<template>
  <VuePerfectScrollbar>
    <div
      id="groovemail-server-table-view"
      class="p-6 groovemail-table-common groovemail-failed-leads-table relative"
    >
      <v-server-table
        ref="failedLeadsTable"
        :columns="failedLeadsDataColumns"
        :url="failedLeadsUrl"
        :options="failedLeadsDataOptions"
        class="text-center"
        @loaded="hideLoader()"
        @loading="showLoader()"
      >
        <div class="flex" slot="exception_message" slot-scope="props">
          <p
            class="overflow-hidden whitespace-nowrap overflow-ellipsis w-80 mr-2"
          >
            {{ props.row.exception_message }}
          </p>
          <div class="cursor-pointer">
            <button
              v-tooltip="{
                content: `<div class='mt-2 break-words'><p>${props.row.exception_message}</p></div>`,
                placement: 'right-start',
                classes: ['info'],
                targetClasses: ['it-has-a-tooltip'],
                offset: 10,
                delay: {
                  show: 200,
                  hide: 300,
                },
              }"
            >
              <i
                class="fas fa-exclamation-circle text-danger text-lg"
                aria-hidden="true"
              ></i>
            </button>
          </div>
        </div>
      </v-server-table>
    </div>
  </VuePerfectScrollbar>
</template>

<script>
import axios from 'axios';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  name: 'broadcast-failed-enteries',

  props: {
    failedLeadsUrl: {
      required: true,
    },
  },

  data() {
    return {
      failedLeadsDataColumns: ['to_email', 'exception_message'],
      failedLeadsDataOptions: {
        perPage: 5,
        debounce: 1000,
        perPageValues: [5],
        pagination: { chunk: 5 },
        requestFunction(data) {
          const self = this;
          const customUrl = self.url.split('?');
          const campaignId = customUrl[1].split('=')[1];
          return axios
            .post(
              customUrl[0],
              { campaign_id: campaignId },
              {
                params: data,
              }
            )
            .catch((e) => {
              self.dispatch('error', e);
            });
        },
        responseAdapter({ data }) {
          return {
            data: data.data,
            count: data.total,
          };
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        sortable: [],
        filterable: [],
        headings: {
          to_email: () => this.$t('frontend_resource_promo_email'),
          exception_message: () =>
            this.$t(
              'frontend_groovemail_suppressions_enter_emails_unsubscribers_reason'
            ),
        },
        rowClassCallback() {
          return 'hover:bg-grey-50 funnelRow';
        },
      },
    };
  },

  components: {
    VuePerfectScrollbar,
  },

  methods: {
    // Triggers emitting event to indicate data has started loading.
    showLoader() {
      this.$emit('showLoader');
    },

    // Triggers emitting event to indicate data has loaded.
    hideLoader() {
      this.$emit('hideLoader');
    },
  },
};
</script>
